import { createContext } from 'react';

export const TileTableContext = createContext({});
